module.exports = new __parcel__URL__("put_to_sleep_button.df590796.png").toString();